<script setup>
  import { h } from 'vue';
  import { Authenticator } from "@aws-amplify/ui-vue";
  import "@aws-amplify/ui-vue/styles.css";

  import { Amplify, Auth } from 'aws-amplify';
  import awsconfig from './aws-exports';

  Amplify.configure(awsconfig);

  const REQUIRED_APP = 'pop';
  const APP_DENIED_MESSAGE = 'You are not allowed to login to this application.';

  const getUserApp = (user) => user?.attributes?.['custom:app']
    || user?.signInUserSession?.idToken?.payload?.['custom:app'];

  const isAuthenticatedUserAllowed = (user) => getUserApp(user) === REQUIRED_APP;

  const UnauthorizedSignOut = {
    props: {
      signOut: {
        type: Function,
        required: true,
      },
    },
    mounted() {
      this.signOut();
    },
    render() {
      return h('div', { class: 'auth-error' }, APP_DENIED_MESSAGE);
    },
  };

  const authenticatorServices = {
    async handleSignIn({ username, password }) {
      const user = await Auth.signIn(username, password);

      if (user?.challengeName) {
        return user;
      }

      if (!isAuthenticatedUserAllowed(user)) {
        await Auth.signOut();
        throw new Error(APP_DENIED_MESSAGE);
      }

      return user;
    },
  };
</script>
<template>
  <authenticator
    :login-mechanisms="['email']"
    :hide-sign-up="true"
    :services="authenticatorServices"
  >
    <template v-slot="{ user, signOut }">
      <div v-if="isAuthenticatedUserAllowed(user)" id="app">
        <router-view />
      </div>
      <UnauthorizedSignOut v-else :sign-out="signOut" />
    </template>
  </authenticator>
</template>
<script>
export default {
  name: "App",
  created () {
      document.title = process.env.VUE_APP_TITLE;
  },
  data: function () {
    return { status: false };
  },
  mounted() {

    $("ul.tabs li").click(function () {
      var $this = $(this);
      var $theTab = $(this).attr("id");
      console.log($theTab);
      if ($this.hasClass("active")) {
        // do nothing
      } else {
        $this
          .closest(".tabs_wrapper")
          .find("ul.tabs li, .tabs_container .tab_content")
          .removeClass("active");
        $(
          '.tabs_container .tab_content[data-tab="' +
            $theTab +
            '"], ul.tabs li[id="' +
            $theTab +
            '"]'
        ).addClass("active");
      }
    });
 
  },
};
</script>
